module.exports = __webpack_public_path__ + "img/logo-EAC6.95ee2499.png";